'use strict';

const controlledPhoneInput = require('./controlledPhoneInput');

/**
 * Handles the state of an input field, adding or removing the 'filled' class
 * based on the input's value, placeholder, or focus state.
 *
 * @param {jQuery} $input - The jQuery object representing the input field.
 */
function handleInputState($input) {
    var $formGroup = $input.closest('.form-group');
    var hasValue = $input.val() ? $input.val().trim() !== '' : false;
    var hasPlaceholder = $input.attr('placeholder') && $input.attr('placeholder').trim() !== '';

    if (hasValue || hasPlaceholder || $input.is(':focus')) {
        $formGroup.addClass('filled');
    } else {
        $formGroup.removeClass('filled');
    }
}

/**
 * Handles the visibility of the placeholder based on the input's focus state.
 * Initially hides the placeholder, shows it on focus, and hides it again on blur if empty.
 *
 * @param {jQuery} $input - The jQuery object representing the input field.
 */
function handlePlaceholderVisibility($input) {
    if ($input.val() && $input.val().trim() !== '') {
        $input.parent().addClass('filled');
    }

    const originalPlaceholder = $input.data('placeholder');

    if (!originalPlaceholder) {
        return;
    }

    $input.on('focus', function() {
        $(this).attr('placeholder', originalPlaceholder);
    });

    $input.on('blur', function() {
        if ($(this).val().trim() === '') {
            $(this).parent().removeClass('filled')
            $(this).attr('placeholder', '');
        }
    });
}

/**
 * Handles the state of an input field inside a form, adding or removing the 'filled' class
 * based on the input's value, placeholder, or focus state.
 *
 * @param {jQuery} $formControls - The form controls to initialize.
 */
function initializeFormControls($formControls) {
    $formControls.each(function() {
        handleInputState($(this));
        handlePlaceholderVisibility($(this));
    });
}

/**
 * Initializes form-related event listeners and handlers.
 * This function sets up event handling for focus, blur, and input events on form controls,
 * and also handles dynamically added inputs.
 */
function initForms() {
    var $formControls = $('.form-control');

    initializeFormControls($formControls);

    $(document).on('focus', '.form-control', function() {
        var $this = $(this);
        $this.closest('.form-group').addClass('focus filled');
    })
    $(document).on('blur', '.form-control', function() {
        var $this = $(this);
        $this.closest('.form-group').removeClass('focus');
        handleInputState($this);
    })
    $(document).on('input', '.form-control:not(select)', function() {
        handleInputState($(this));
    })

    $(document).on('change', '.form-control:not(select)', function() {
        handleInputState($(this));
    });

    $(document).on('initDynamicForm', function(e, $controls) {
        initializeFormControls($controls);

        var $phoneInput = $controls.filter('.form-control.controlledPhoneInput');
        if ($phoneInput.length) {
            $(document).trigger('formatPhoneInputValue', $phoneInput);
            controlledPhoneInput.initControlledPhoneInput();
        }

        $(document).trigger('reinitClientSideValidation');
    });
}

module.exports = {
    init: initForms
};
